var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-alert',{staticClass:"red--text",attrs:{"error":"","dismissible":"","value":true},on:{"input":_vm.onClose}},[_vm._v(" "+_vm._s(_vm.alerttext)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }